import type {SubmitHandler as HookFormSubmitHandler} from 'react-hook-form';

export type FieldValues = {
  barcode: string;
  confirmBarcode: string;
  form?: string;
};

export type SubmitHandler = HookFormSubmitHandler<FieldValues>;

export class LabExistsError extends Error {}
